
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"13","viewBox":"0 0 19 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.4282 8.94564C1.96123 8.50003 1.59341 7.96442 1.34789 7.37255C1.10237 6.78067 0.98448 6.14536 1.00164 5.50661C1.01879 4.86787 1.17063 4.23952 1.44758 3.66115C1.72453 3.08277 2.1206 2.56689 2.61084 2.146C3.10109 1.72511 3.67489 1.40832 4.29611 1.21558C4.91733 1.02285 5.57252 0.958335 6.22042 1.02611C6.86831 1.09389 7.49488 1.29249 8.06066 1.6094C8.62645 1.92631 9.11919 2.35467 9.50787 2.86751C9.89822 2.3584 10.3915 1.93378 10.9569 1.62023C11.5223 1.30668 12.1476 1.11095 12.7937 1.04529C13.4398 0.979633 14.0927 1.04546 14.7117 1.23864C15.3306 1.43183 15.9022 1.74822 16.3908 2.16802C16.8793 2.58781 17.2742 3.10197 17.5508 3.67832C17.8273 4.25467 17.9796 4.8808 17.9981 5.51751C18.0166 6.15423 17.9008 6.78784 17.6581 7.37867C17.4154 7.9695 17.0509 8.50485 16.5875 8.9512L10.2352 15.6834C9.84044 16.1018 9.17491 16.1017 8.78029 15.6831L2.4282 8.94564Z","stroke":"#484444","stroke-width":"2","stroke-linejoin":"round"}})])
          )
        }
      }
    